import { CheckCircle2, XCircle, Clock, Lock, RefreshCw, Circle, PlayCircle } from "lucide-react";

const MAP = {
  approved: { bg: "#142E1F", border: "#276239", text: "#6EE7B7", icon: CheckCircle2 },
  completed: { bg: "#142E1F", border: "#276239", text: "#6EE7B7", icon: CheckCircle2 },
  passed: { bg: "#142E1F", border: "#276239", text: "#6EE7B7", icon: CheckCircle2 },
  rejected: { bg: "#3B1414", border: "#7F1D1D", text: "#FCA5A5", icon: XCircle },
  failed: { bg: "#3B1414", border: "#7F1D1D", text: "#FCA5A5", icon: XCircle },
  pending: { bg: "#332208", border: "#784302", text: "#FDE047", icon: Clock },
  in_progress: { bg: "#332208", border: "#784302", text: "#FDE047", icon: PlayCircle },
  blocked: { bg: "#222026", border: "#4C4656", text: "#D8B4FE", icon: Lock },
  locked: { bg: "#222026", border: "#4C4656", text: "#D8B4FE", icon: Lock },
  reattempt: { bg: "#132738", border: "#1E4B70", text: "#93C5FD", icon: RefreshCw },
  not_started: { bg: "#141414", border: "#4a3a2c", text: "#C9CDD3", icon: Circle },
};

export function StatusBadge({ status, label, testid }) {
  const s = MAP[status] || MAP.not_started;
  const Icon = s.icon;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border"
      style={{ background: s.bg, borderColor: s.border, color: s.text }}>
      <Icon className="w-3.5 h-3.5" aria-hidden />
      <span>{label}</span>
    </span>
  );
}
